import Ajax from "Utils/ajax";
export const leaveType = () => Ajax.post('hr/leaveType');
export const leaveMatrix = (data) => Ajax.post('hr/leaveMatrix',data);
export const leavePlanMatrix = (data) => Ajax.post('hr/leaveReason',data);
export const getLeaveDetailsToApprove = (data) => Ajax.post('hr/getLeaveDetailsToApprove',data);
export const getUserNameById = (data) => Ajax.post('hr/getUserNameById',data);
export const changeLeaveStatus = (data) => Ajax.post('hr/changeLeaveStatus',data);
export const reSubmitLeave = (data) => Ajax.post('hr/reSubmitLeave',data);